export default __webpack_public_path__ + "static/media/Gujarat_2.01b5abad.png";